// src/constants/index.ts

// 定义全局通用的分页选项
export const PAGE_SIZE_OPTIONS = [50, 100, 200];

// 如果你也需要统一默认的每页数量
export const DEFAULT_PAGE_SIZE = 100;

// 舆情问题分类选项（统一用于编辑与筛选）
export const PROBLEM_CLASS_OPTIONS = [
  '价格问题',
  '技术问题',
  '时效问题',
  '配件问题',
  '服务规范',
  '服务态度',
  '广告问题',
  '其他',
];

// 任务分发使用的部门选项，其他页面需要同一批部门时直接复用这里。
export const TASK_DISPATCH_DEPARTMENT_OPTIONS = [
  '品牌部',
  '售后客服部',
  '合规经营部',
  '法务部',
  '人事管理&资产管理&内控部',
  '渠道团队',
  '解决方案部',
  '交付产品事业部',
  '工程师供给部',
  '稽查部',
  '司南开发',
  '北京子公司',
  '长春子公司',
  '唐山子公司',
  '大连子公司',
  '天津子公司',
  '哈尔滨子公司',
  '沈阳子公司',
  '济南子公司',
  '青岛子公司',
  '潍坊子公司',
  '烟台子公司',
  '临沂子公司',
  '徐州子公司',
  '淮安子公司',
  '郑州子公司',
  '保定子公司',
  '呼和浩特子公司',
  '洛阳子公司',
  '石家庄子公司',
  '太原子公司',
  '上海子公司',
  '杭州子公司',
  '宁波子公司',
  '温州子公司',
  '苏州子公司',
  '常州子公司',
  '南京子公司',
  '无锡子公司',
  '南通子公司',
  '广州子公司',
  '东莞子公司',
  '佛山子公司',
  '福州子公司',
  '厦门子公司',
  '泉州子公司',
  '海口子公司',
  '中山子公司',
  '珠海子公司',
  '深圳子公司',
  '惠州子公司',
  '西安子公司',
  '银川子公司',
  '兰州子公司',
  '乌鲁木齐子公司',
  '西宁子公司',
  '昆明子公司',
  '贵阳子公司',
  '成都子公司',
  '绵阳子公司',
  '遵义子公司',
  '重庆子公司',
  '南宁子公司',
  '武汉子公司',
  '长沙子公司',
  '南昌子公司',
  '合肥子公司',
];
